// extracted by mini-css-extract-plugin
module.exports = {"SuccessMessage":"SuccessMessage_SuccessMessage__424AS","Overlay":"SuccessMessage_Overlay__2s71_"};